import React from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../components/PageShell';
import Card from '../components/Card';
import { NAV } from '../components/Sidebar';
import './WipHomePage.css';

/* Chantier — sommaire du module `wip` (décision Olivier 2026-08-26).

   Le module sert de garage aux écrans en construction : on les y range le temps
   de les finir, puis ils rejoignent leur module définitif. Il n'est coché dans
   aucun pack client, donc rien de ce qui vit ici n'atteint un client.

   Cette page ne tient PAS sa propre liste : elle lit les sections de la bande
   `wip` dans NAV (source unique de l'ordre du menu). Ranger un écran ici se fait
   donc à un seul endroit, et le sommaire suit. */
export default function WipHomePage({ setPage }) {
  const { t } = useTranslation();
  // Le sommaire ne liste QUE le groupe « en construction » : l'outillage
  // d'exploitation (Journal) vit sous la même icône mais n'est pas un chantier.
  const band = NAV.find((n) => n.type === 'band' && n.id === 'wip');
  const building = (band?.groups || []).find((g) => g.id === 'building');
  const items = (building?.items || []).filter((it) => it.key && it.key !== 'wip-home');

  return (
    <PageShell framed timeless title={t('nav:items.wip-home')}>
      <Card>
        <p className="wip-lead">{t('common:wip.lead')}</p>
        <p className="wip-rule">{t('common:wip.rule')}</p>
        {items.length === 0 ? (
          <p className="wip-empty">{t('common:wip.empty')}</p>
        ) : (
          <>
          <p className="wip-listtitle">{t('common:wip.listTitle')}</p>
          <ul className="wip-list">
            {items.map((it) => (
              <li key={it.key}>
                <button type="button" className="wip-link" onClick={() => setPage && setPage(it.key)}>
                  {it.labelKey ? t(it.labelKey) : it.label}
                </button>
              </li>
            ))}
          </ul>
          </>
        )}
      </Card>
    </PageShell>
  );
}
